var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "inline-flex relative dropdown",
      attrs: {
        "data-testid": "accountButton",
        tabindex: "0",
        role: "button",
        "aria-label": _vm.$t("Open my account")
      },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          _vm.goToAccount()
          _vm.showMenu = true
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.goToAccount($event)
        },
        mouseover: function($event) {
          _vm.showMenu = true
        },
        mouseout: function($event) {
          _vm.showMenu = false
        }
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("no-ssr", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentUser,
                expression: "currentUser"
              }
            ],
            class: [
              "dropdown-content bg-cl-primary align-left sans-serif lh20 weight-400",
              !_vm.showMenu ? "dropdown-content__hidden" : ""
            ]
          },
          [
            _c(
              "div",
              { staticClass: "py5" },
              _vm._l(_vm.navigation, function(page, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    on: {
                      click: function($event) {
                        return _vm.notify(page.title)
                      }
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "no-underline block py10 px15",
                        attrs: { to: _vm.localizedRoute(page.link) },
                        nativeOn: {
                          click: function($event) {
                            _vm.showMenu = false
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(page.title) + "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "py5 brdr-top-1 brdr-cl-bg-secondary" }, [
              _c(
                "a",
                {
                  staticClass: "no-underline block py10 px15",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.logout($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("Logout")) + "\n        "
                  )
                ]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "bg-cl-transparent brdr-none p0",
        attrs: { type: "button" }
      },
      [_c("i", { staticClass: "material-icons block" }, [_vm._v("person")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }